export default __webpack_public_path__ + "static/breadJang-fffbe9fa17c81095bffc33a66da85755.png";